
const digest = 'ba8cedb9f0c26db6d038a547d041ae4033d5d58e0724d711ba1b6d24dd41745c';
const css = `._selectionRectangle_1g7wa_1 {
  display: flex;
  position: relative;
  border-radius: 4px;
  outline-offset: 0px;
  max-width: 100%;
}

._selectionRectangleInline_1g7wa_9 {
  display: inline-flex;
}

._selectionRectangleSelected_1g7wa_13 {
  outline: 2px solid rgb(var(--aha-editor-v2--selection-outline-color));
}

._selectionRectangleMargin_1g7wa_17 {
  outline-offset: 2px;
}

._selectionRectangleBackground_1g7wa_21 {
  background-color: var(--theme-list-item-active-background);
}

._selectionRectangleFill_1g7wa_25 {
  width: 100%;
  height: 100%;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionRectangle":"_selectionRectangle_1g7wa_1","selectionRectangleInline":"_selectionRectangleInline_1g7wa_9","selectionRectangleSelected":"_selectionRectangleSelected_1g7wa_13","selectionRectangleMargin":"_selectionRectangleMargin_1g7wa_17","selectionRectangleBackground":"_selectionRectangleBackground_1g7wa_21","selectionRectangleFill":"_selectionRectangleFill_1g7wa_25"};
export { css, digest };
  